import React, { Component } from "react";
import './style.css'
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import { getQueryParams } from './utils';
import AgreeModal from './AgreeModal';
import { saveLogin, getPublicIP } from './utils';
import { Auth } from "aws-amplify";
import axios from 'axios';
import configurations from "../../configurations";
import Loader from './loader'

export class LaunchAgent extends Component {
    constructor(props) {
        super(props);
        this.emailInput = React.createRef();
        this.passwordInput = React.createRef();
        this.state = {
            agreeModal: this.props.agreeModal,
            errorMsg: ''
        }
    }

    componentDidMount() {
        let urlValues = window.location.hash ? window.location.hash.split('=') : [];
        if (urlValues && urlValues.length > 0) {
            if (urlValues[1]) {
                this.getDecodeData(urlValues[1]);
            }
        }
    }

    toggleLoader = (value) => {
        this.setState({
            showLoader: value
        })
    }

    getDecodeData = (value) => {
        this.toggleLoader(true)
        axios.get(configurations.baseUrl + '/encrypt/decryptData?state=' + value)
            .then(response => {
                if (response.data.response) {
                    sessionStorage.setItem('STATE_PARAM', JSON.stringify(response.data.response));
                    let agentDetails = sessionStorage.setItem('STATE_PARAM', JSON.stringify(response.data.response))
                    this.setState({
                        username: response.data.response.username,
                        password: response.data.response.password,
                        showLoader: false
                    }, () => this.handleSubmit())
                }
            });
    }

    handleSubmit = async (event) => {
        console.log('submit')
        this.toggleLoader(true)
        const { username, password } = this.state;
        this.setState({
            errorMesssage: ''
        })
        console.log('username:::', username);
        const authUser = await Auth.signIn({
            username: username,
            password: password,
        }).catch(err => {
            this.setState({
                errorMesssage: 'Incorrect username or password.',
                disableSiginBtn: false
            })
            this.toggleLoader(false)
        });
        this.toggleLoader(false)
        if (authUser) {
            if (authUser.challengeName === 'SMS_MFA' ||
                authUser.challengeName === 'SOFTWARE_TOKEN_MFA') {
                this.setState({
                    user: authUser,
                    sendMFA: true,
                    disableSiginBtn: false
                })
            } else if (authUser.challengeName === "NEW_PASSWORD_REQUIRED") {
                this.setState({
                    user: authUser,
                    disableSiginBtn: false,
                    firstTimepwdRest: true,
                })
            } else {
                this.setState({
                    disableSiginBtn: false
                });
                localStorage.setItem("IAgree", "true")
                localStorage.setItem("launchAgent", true)
                saveLogin(username)
                sessionStorage.setItem('isLogged', false);
                this.props.history.push('/')
            }
        }

        // this.setState({
        //     disableSiginBtn: false
        // });
        // localStorage.setItem("IAgree", "false")
        // localStorage.setItem("launchAgent", true)
        // localStorage.setItem("agentEmail", username)
        // saveLogin(username)
        // sessionStorage.setItem('isLogged', false);
        // this.props.history.push('/')
    }

    render() {
        return (
            <div className="NetWellPortalLoginDesktop">
                <Loader showLoader={this.state.showLoader} />
            </div>
        )
    }
}
export default LaunchAgent;
